import { render, staticRenderFns } from "./StaffTempMoment.vue?vue&type=template&id=201db649&scoped=true"
import script from "./StaffTempMoment.vue?vue&type=script&lang=js"
export * from "./StaffTempMoment.vue?vue&type=script&lang=js"
import style0 from "./StaffTempMoment.vue?vue&type=style&index=0&id=201db649&prod&scoped=true&lang=css"
import style1 from "./StaffTempMoment.vue?vue&type=style&index=1&id=201db649&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201db649",
  null
  
)

export default component.exports